const tableTitleFrequency = {
  title: 'Periodicidades',
  placeholder: 'Buscar',
  Typography: 'Ningún resultado encontrado'
};

export default tableTitleFrequency;
